import { CheckIcon } from 'lucide-react';
import { QuestionOption, OptionLayout } from '../types/form';
import { OtherField } from './OtherField';
interface ListOptionRowProps {
  option: QuestionOption;
  shortcut: string;
  layout: Extract<OptionLayout, 'timeline' | 'scale'>;
  /** 0-based position among the non-"Outros" options. */
  rank: number;
  steps: number;
  selected: boolean;
  otherText: string;
  onSelect: () => void;
  onOtherChange: (value: string) => void;
}
export function ListOptionRow({
  option,
  shortcut,
  layout,
  rank,
  steps,
  selected,
  otherText,
  onSelect,
  onOtherChange
}: ListOptionRowProps) {
  return <button type="button" role="radio" aria-checked={selected} onClick={onSelect} className={`group flex w-full items-center gap-5 border-b px-2 py-5 text-left transition-colors duration-200 ease-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 ${selected ? 'border-cream-100/60 bg-olive-600/60' : 'border-cream-100/12 hover:bg-olive-700/50'}`} data-id="element-38" data-mp="12neyprt9bki0">
      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border font-sans text-[11px] transition-colors duration-200 ease-soft ${selected ? 'border-cream-100 bg-cream-100 text-olive-800' : 'border-cream-100/30 text-cream-100/70'}`} aria-hidden="true" data-id="element-39" data-mp="ksypmylvlt3w">
        {selected ? <CheckIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-40" data-mp="6tpkqv34elf8" /> : shortcut}
      </span>

      <span className="min-w-0 flex-1" data-id="element-41" data-mp="1v4hemsknlmk">
        <span className="block font-display text-2xl leading-tight text-cream-50" data-id="element-42" data-mp="1wfnwudej7hd">
          {option.label}
        </span>
        {option.detail && <span className="mt-0.5 block font-sans text-xs uppercase tracking-[0.18em] text-cream-100/50" data-id="element-43" data-mp="atpxmbakmok6">
            {option.detail}
          </span>}
        {option.isOther && selected && <span className="mt-3 block" data-id="element-44" data-mp="1m8wkfuy1kp7s">
            <OtherField value={otherText} placeholder="Digite aqui" onChange={onOtherChange} data-id="element-45" data-mp="1mcakuxn5aocl" />
          </span>}
      </span>

      {!option.isOther && layout === 'scale' && <span className="hidden shrink-0 items-end gap-1 sm:flex" aria-hidden="true" data-id="element-46" data-mp="ots2zibtfjgy">
          {Array.from({
        length: steps
      }, (_, i) => <span key={i} style={{
        height: `${10 + i * 8}px`
      }} className={`w-2 transition-colors duration-200 ease-soft ${i <= rank ? 'bg-gold-400' : 'bg-cream-100/15'}`} data-id="element-47" data-mp="xw1dw9azxeuv" />)}
        </span>}

      {!option.isOther && layout === 'timeline' && <span className="hidden shrink-0 items-center gap-1.5 sm:flex" aria-hidden="true" data-id="element-48" data-mp="a55k56mzc9kz">
          {Array.from({
        length: steps
      }, (_, i) => <span key={i} className={`h-1.5 rounded-full transition-colors duration-200 ease-soft ${i <= rank ? 'bg-gold-400' : 'bg-cream-100/15'} ${i === rank ? 'w-6' : 'w-1.5'}`} data-id="element-49" data-mp="3dnp31ijrq334" />)}
        </span>}
    </button>;
}